import React, { type ReactNode } from 'react';
import { type LucideIcon } from 'lucide-react';
import { Header1 } from '../components/text/Header1';
import { Subtitle } from '../components/text/Subtitle';

export interface PageSectionProps {
	TitleIcon?: LucideIcon;
	title: string;
	description?: string;
	headerRightSlot?: ReactNode;
	children: ReactNode;
}

export function PageSection({ title, description, headerRightSlot, TitleIcon, children }: PageSectionProps) {
	return (
		<div className="rounded-xl border border-gray-200 bg-white shadow-sm">
			<div className="p-4">
				<div className="mb-6 flex items-center justify-between">
					<div>
						<div className="mb-3 flex items-center gap-3">
							{TitleIcon && (
								<div className="rounded-lg bg-primary-50 p-2">
									<TitleIcon className="size-6 text-primary-600" />
								</div>
							)}
							<Header1>{title}</Header1>
						</div>
						{description && <Subtitle className="ml-1">{description}</Subtitle>}
					</div>
					{headerRightSlot && <div className="flex flex-row">{headerRightSlot}</div>}
				</div>
				{children}
			</div>
		</div>
	);
}
